export default __webpack_public_path__ + "static/media/wi-day-rain.320e0e5a.svg";